<template>
<div> 
    <div class="cabin-footer__wrapper">
        <div class="cabin-footer__second">
            <div v-if="is('tariff')" :class="`${baseClass}__line`">
                <div :class="`${baseClass}__name`">Тариф</div>
                <div :class="`${baseClass}__value`">
                    <!-- Только на морских, тарифная часть -->
                    <strong>{{show_price('tariff')}}
                        <span>
                            {{symb('tariff')}}
                        </span>
                    </strong>
                </div>
            </div>
            <div v-if="is('dues')" :class="`${baseClass}__line`">
                <div :class="`${baseClass}__name`">Сборы</div>
                <div :class="`${baseClass}__value`">
                    <!-- Только на морских, портовые сборы / бывает цифра 0 не ясно почему, цена обязательная -->
                    <strong>{{show_price('dues')}}
                        <span>
                            {{symb('dues')}}
                        </span>
                    </strong>
                </div>
            </div>
        </div>

        <div class="cabin-footer__main" @click="toggleHidden">
            <div :class="`${baseClass}__line`">
                <div :class="`${baseClass}__name`">Итого:</div>
                <div :class="`${baseClass}__value`">
                    <template v-if="precalc && precalc.calc.wait">
                        <Loader class="cp-loader" />
                    </template>
                    <template v-else-if="precalc && precalc.calc.ok && precalc.calc.acc">
                        <!-- Основная цена, бывшая итого -->
                        <strong>{{show_price('v')}}
                            <span :title="title()">
                                {{symb('v')}}
                            </span>
                        </strong>
                    </template>
                </div>
            </div>
        </div>
    </div>
    
    <div class="cabin-footer__hidden" :class="{ '_active': isHiddenActive }">
        <div v-if="is('comm')" :class="`${baseClass}__line`">
            <div :class="`${baseClass}__name`">Комиссия {{show_pcomm()}}</div>
            <div :class="`${baseClass}__value`">
                <!-- Комиссия, которую получает агент с этой суммы. У нее есть 2 значения в валюте и процентах. Эту штуку надо скрывать -->
                <strong>{{show_price('comm')}} {{symb('comm')}}</strong>
            </div>
        </div>
        <div v-if="is('comm')" :class="`${baseClass}__line`">
            <div :class="`${baseClass}__name`">К оплате агентом</div>
            <div :class="`${baseClass}__value`">
                <strong>{{show_agent_sum()}}
                    <span>
                        {{symb('comm')}}
                    </span>
                </strong>
            </div>
        </div>
    </div>
</div>
</template>

<style lang="scss">
.cp-loader {height: 16px;}
</style>

<script setup>
import { ref, unref, computed } from 'vue'
import { formatPrice } from '@/util.js'
import { _get } from '@/actions.js'
import Loader from '@/comp/Loader/Loader.vue'

const isHiddenActive = ref(false)
const toggleHidden = () => {
    isHiddenActive.value = !isHiddenActive.value 
//console.log('toggleHidden')
}

const props = defineProps({
    precalc : Object,
    cabinId : Number,
    childClass : String,
    sum: { // если true - то нужно вычислить сумму
        type: Boolean,
        default: false,
    },
})

const baseClass = computed(() => {
    return props.childClass ?? 'CabinPrice'
})


const is = (field) => {
    let ret = false
    let ok = props.precalc && props.precalc.calc.ok && props.precalc.calc.acc
    if (ok) {
        const source = price_source()
        ret = source && Array.isArray( source[ field ] )
    }
    return ret
}

const sumcalc = computed(() => {
    let ret = {}
    let from = _get(props.precalc, 'calc.calc_prices')
    if (from && 'object' === typeof(from)) {
        ret = Object.entries(from).reduce( (akk, [cabinId, prices]) => {
            for (let ff of ["v", "tariff","dues", "comm"]) {
                let old = prices[ ff ]
                if (!old) {
                    continue;
                }
                const p = ff in akk ? akk[ff][0] : 0
                akk[ff] = [p + old[0], old[1] ]
            }
            return akk
        }, {} )
    }

    return ret
})


const price_source  = () => {
    return props.sum ? unref(sumcalc) : props.precalc.calc.calc_prices[ props.cabinId ]
}
const show_price = field => {
    const source = price_source()
    const val = source[ field ][0]
    return formatPrice( val )
}
const show_agent_sum = () => {
    const source = price_source()
    const total = source.v[0]
    const comm = source.comm[0]
    const val  = total - comm
    const ret = formatPrice(val)
    return ret
}
const symb = field => {
    const source = price_source() 
    const val = source[ field ][1]
    return CURRENCY_SYMBOL[val]
}
const show_pcomm = () => {
    let ret = ''
    if (is('comm')) {
        const cab0 = Object.values(props.precalc.calc.calc_prices)[0]    
        ret = cab0.pcomm+'%'
    }
    
    return ret
}
const title = () => {
    return _get(props.precalc, 'calc.ok') ? props.precalc.calc.src : '...'
}


const CURRENCY_SYMBOL = {
    "1" : 'руб.', // ₽
    "2" : 'usd',
    "3" : 'eur',
}

    
</script>